import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, catchError, map } from 'rxjs';
import { DataTablesResponse } from '../models/datatables';
import { UeckoCountryDTO } from '../models/country-dto';


@Injectable({
  providedIn: 'root'
})

export class CountryService {

  private pathAPI = environment.urlAPI;
  private controller = "UeckoCountry/";

  public CountryData = new BehaviorSubject<UeckoCountryDTO>(null);

  constructor(private http: HttpClient) { }


   public get(id: string): Observable<UeckoCountryDTO> {
      return this.http.get<UeckoCountryDTO>(this.pathAPI + this.controller + id);
    }
  
    public post(data: UeckoCountryDTO): Observable<any> {
      return this.http.post<any>(this.pathAPI + this.controller, data);
    }
  
    public put(id: string, data: UeckoCountryDTO): Observable<any> {
      return this.http.put<any>(this.pathAPI + this.controller + id, data);
    }
  
    public changeStatus(id: string, idStatus: number): Observable<any> {
      return this.http.put<any>(this.pathAPI + this.controller + 'ChangeStatus/' + id + '/' + idStatus, null);
    }

    public changeStatusLanguage(id: string, idStatus: number): Observable<any> {
      return this.http.put<any>(this.pathAPI + this.controller + 'ChangeStatusLanguage/' + id + '/' + idStatus, null);
    }
  
    public getDataTable(data: any): Observable<DataTablesResponse> {
      return this.http.post<DataTablesResponse>(this.pathAPI + this.controller + 'GetDataTable/', data);
    }
  
  

  public getActiveLanguageList(): Observable<UeckoCountryDTO[]> {
    return this.http.get<UeckoCountryDTO[]>(this.pathAPI + this.controller + 'GetActiveLanguageList');
  }

 
}